// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-492b987a] .el-form-item__content{line-height:20px!important;color:#606166;font-weight:400}[data-v-492b987a] .el-form-item__label{padding-bottom:0!important;line-height:20px!important}.el-form-item[data-v-492b987a]{margin-bottom:5px!important}", ""]);
// Exports
module.exports = exports;
